import React, { useCallback, useMemo, useState } from 'react'
import InfoBox, { InfoBoxItem } from './InfoBox'

export const useInfoBox = <T extends HTMLElement = HTMLElement>() => {
	const [infoItems, setInfoItems] = useState<InfoBoxItem<T>[]>([])
	const [isOpen, setIsOpen] = useState(false)

	const open = useCallback((items: InfoBoxItem<T>[]) => {
		if (items.length > 0) {
			setInfoItems(items)
			setIsOpen(true)
		}
	}, [])

	const close = useCallback(() => {
		setIsOpen(false)
	}, [])

	const InfoBoxComponent = useMemo(() => {
		if (!isOpen || infoItems.length === 0) return null

		return <InfoBox infoItems={infoItems} open={isOpen} onClose={close} />
	}, [isOpen, infoItems, close])

	return {
		open,
		close,
		InfoBoxComponent,
	}
}
